module.exports = __webpack_public_path__ + "static/media/london-39.6f1dc437.jpg";